<template>
  <div class="card">
    <div class="top">
      <div class="t_left">
        <span @click="$emit('changeShowCard', 0)" v-if="showCard!=-1">{{ lang.overviewOfProgress }}</span>
        <span @click="$emit('changeShowCard', 1)" v-if="showCard!=-1">{{lang.difficultProblems}}</span>
        <span @click="$emit('changeShowCard', 2)" class="active">{{ lang.abilityStratification }}</span>
        <span @click="$emit('changeShowCard', 3)" v-if="showCard!=-1">{{lang.teachingSuggestions}}</span>
      </div>
      <div class="t_right" v-if="false">
        <img
          src="../../../../assets/img/teachingMode/changeUp.png"
          :style="{ cursor: showCard > 0 ? 'pointer' : 'not-allowed' }"
          @click="$emit('changeShowCard', 0)"
        />
        <img
          src="../../../../assets/img/teachingMode/changeDown.png"
          :style="{ cursor: showCard < 3 ? 'pointer' : 'not-allowed' }"
          @click="$emit('changeShowCard', 1)"
        />
      </div>
    </div>
    <div class="main">
      <div class="m_item" v-for="(item, index) in cardData" :key="index">
        <div
          class="mi_top"
          :style="{ background: item.bgColor, color: item.tColor }"
        >
          <div>{{ item.title }}</div>
          <span>{{ item.brief }}</span>
        </div>
        <div class="mi_userArea" v-if="item.user.length > 0"  :style="exportBoolean?`box-shadow:none`:''">
          <div class="mi_ua_top">
            <span>{{ item.user.length }}<span>人</span></span>
            <img
              :class="{ mi_ua_t_active: item.showAllUser }"
              @click="item.showAllUser = !item.showAllUser"
              src="../../../../assets/img/teachingMode/u_arrow2.png"
            />
          </div>
          <div
            class="mi_ua_userList"
            :class="{ mi_ua_u_active: !item.showAllUser }"
           
          >
            <div
              class="mi_ua_u_t_item"
              v-for="(user, userIndex) in item.user"
              :key="userIndex"
            >
            <!-- <span slot="reference">{{ user.name }}</span> -->
              <el-popover placement="bottom" width="300" trigger="hover">
                <div class="mi_ua_u_t_i_popover">
                  <span>{{ lang.summary }}</span>
                  <div>{{ user.summary }}</div>
                  <span>{{ lang.personalizedSuggestions }}</span>
                  <div>{{ user.suggestion }}</div>
                </div>
                <span slot="reference">{{ user.name }}</span>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myMixin } from "@/common/mixin";
export default {
  mixins: [myMixin],
  props: {
    analysisData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showCard: {
      type: Number,
      default: 0,
    },
    exportBoolean:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      // cardData: [],
      statusList: [
        this.lang.unfinished,
        this.lang.completed,
        this.lang.pause,
        this.lang.stop,
      ],
    };
  },
  computed: {
    cardData() {
      let _result = [];

      if (this.analysisData && this.analysisData.length > 0) {
        _result = JSON.parse(JSON.stringify(this.analysisData));
      }

      return _result;
    },
  },
  methods: {
    generated(list, num = 0) {
      return new Promise((resolve) => {
        let _msg = "";
        list.forEach((s) => {
          _msg += `学生：${s.name}\n总结：${s.summary}\n总节点数量：${
            s.stage
          }\n任务状态：${this.statusList[s.status]}\nID：${s.id}\n`;
          s.nodeData.forEach((n, nIndex) => {
            _msg += `【节点${(nIndex + 1).toString().padStart(2, "0")} ${
              n.messageList[0] ? n.messageList[0].aiName : "-"
            }】表情：${
              n.status == "0" ? "微笑" : n.status == "1" ? "不高兴" : "无表情"
            }\n`;
            n.messageList.forEach((m) => {
              _msg += `${m.userName}(${m.chatTime})：\n${m.userContent}\n${m.aiName}：\n${m.aiContent}\n`;
            });
          });
          _msg += "\n";
        });

        let _msg2 = `NOTICE
Role: 你是一个专业的教育评估分析师，需要基于学生在AI学习助手中的学习表现和对话记录，将学生按照学习能力和掌握程度进行科学分层，为教师提供差异化教学的依据。
Language: Please use the same language as the user requirement, if the user speaks Chinese, the specific text of your answer should also be in Chinese.
ATTENTION: Use '##' to SPLIT SECTIONS, not '#'. Output format carefully referenced "Format example".
Instruction: Based on the context, follow "Format example", write content

#Context
你需要完成：
1. 根据学习表现将学生分为优秀、良好、待提升三个层次
2. 为每个层次提供准确的整体特征描述
3. 分析每个学生的具体表现和个性化特点
4. 确保分层结果科学合理，能指导个性化教学

# 输入信息

## 学生学习数据
${_msg}

# 分层标准与评估维度

## 1. 学习完成度评估
**完成质量指标**：
- 任务完成状态（已完成/未完成）
- 学习节点推进程度（到达的最高节点）
- 学习持续性（是否中途放弃）
- 时间管理（完成效率和节奏）

## 2. 知识掌握程度评估
**理解深度指标**：
- 概念理解的准确性和全面性
- 知识应用的灵活性和创新性  
- 错误纠正的速度和效果
- 知识迁移和举一反三能力

## 3. 学习过程质量评估
**学习行为指标**：
- 主动思考和提问的频率
- 回答的详细程度和逻辑性
- 与AI互动的有效性
- 自我反思和总结能力

## 4. 学习态度与动机评估
**学习态度指标**：
- 学习积极性和主动性
- 面对困难的坚持程度
- 对学习内容的兴趣表现
- 自我调节和情绪管理能力

# 分类标准

## 优秀组特征
**核心表现**：
- 学习任务高质量完成，进度领先
- 概念理解深入透彻，能够灵活应用
- 主动思考，经常提出有价值的问题
- 学习过程中表现出创新思维和批判性思考

**识别标志**：
- 回答完整且逻辑清晰
- 能主动连接不同知识点
- 快速理解和掌握新概念
- 积极参与互动，质量高
- 能够自我反思和优化学习策略

## 良好组特征
**核心表现**：
- 基本完成学习任务，掌握核心知识点
- 概念理解基本正确，需要适当引导才能灵活应用
- 学习态度积极，但主动性有待提升
- 在教师或AI指导下能够解决大部分问题

**识别标志**：
- 能正确回答基础问题
- 在提示下能够理解进阶概念  
- 学习节奏稳定，较少出现重大困难
- 参与互动积极，但深度有限
- 需要外部激励和指导

## 待提升组特征
**核心表现**：
- 学习任务完成困难，进度明显滞后
- 基础概念理解存在偏差或不够深入
- 学习动机不足，容易出现消极情绪
- 需要更多支持和个性化指导

**识别标志**：
- 频繁出现理解错误或困惑
- 回答简短，缺乏深度思考
- 容易放弃或表现出挫败情绪
- 对困难问题回避或消极应对
- 需要重点关注和额外支持

# 个性化特点描述指南

## 描述维度
每个学生的个性化描述应包含以下维度中的2-3个突出特点：

**学习能力维度**：
- 理解速度（快速理解/需要时间消化/理解困难）
- 应用能力（灵活应用/基础应用/应用困难）
- 创新思维（有创新见解/思维常规/缺乏创新）

**学习行为维度**：
- 参与程度（积极主动/适度参与/参与消极）
- 提问质量（深度思考/一般提问/很少提问）
- 坚持程度（持续努力/偶尔放弃/容易放弃）

**学习态度维度**：
- 学习兴趣（浓厚兴趣/一般兴趣/兴趣不足）
- 自我调节（自主学习/需要提醒/依赖指导）
- 情绪管理（积极乐观/情绪平稳/容易消极）

## 描述语言要求
- **具体化**：避免抽象泛泛的描述，要有具体的表现实例
- **差异化**：突出每个学生的独特特点，避免千篇一律
- **建设性**：即使是待提升学生，也要发现其积极因素
- **简洁性**：每个学生的描述控制在15-25字内

# 分层质量检验标准
## 标准一致性
- 同一层次内学生的能力水平应该相对一致
- 不同层次间应有明显的能力差异
- 分层结果应与学习完成情况基本吻合
- 避免仅以完成度作为单一标准

# 其他重要提示
1. **基于事实分析，保持客观中性**：所有分析结论必须基于实际的对话数据，避免主观推测；使用专业术语，避免对学生进行负面标签化或价值判断；不仅识别问题，也要发现学生的优势和成功模式
2. **注重可操作性**：提供的洞察和建议应该具体可行，能指导教师采取实际行动；优先分析最新的学习状态和最近的变化趋势
3. **考虑个体差异**：认识到不同学生的学习方式、节奏和需求存在差异
4. **数据隐私保护**：在分析过程中保护学生隐私，使用适当的概括性描述
5. **完整性检查**：确保所有学生的学习状态都被纳入分析范围，无遗漏

请基于提供的学生学习数据，运用上述标准和方法进行科学的能力分层分析。

# Format example
[{"title":"优秀","bgColor":"#BCE685","tColor":"#fff","brief":"{整体特征描述}","showAllUser":false,"user":[{"name":"{学生姓名}","summary":"{具体表现描述}","suggestion":"{个性化建议}"}]},{"title":"良好","bgColor":"#3681FC","tColor":"#fff","brief":"{整体特征描述}","showAllUser":false,"user":[{"name":"{学生姓名}","summary":"{具体表现描述}","suggestion":"{个性化建议}"}]},{"title":"需提升","bgColor":"#F06643","tColor":"#fff","brief":"{整体特征描述}","showAllUser":false,"user":[{"name":"{学生姓名}","summary":"{具体表现描述}","suggestion":"{个性化建议}"}]}]
`;

        let message = [{ role: "user", content: _msg2 }];
        this.chat_no_stream(message)
          .then((res) => {
            try {
              if (res) {
                let _group = JSON.parse(res);
                resolve(_group);
              } else {
                // 若response为空视为catch流程
                if (num < 4) {
                  this.generated(list, num + 1).then(resolve);
                } else {
                  resolve([]);
                }
              }
            } catch (error) {
              // 若解析失败则重试，最多5次（num从0 ~ 4）
              if (num < 4) {
                this.generated(list, num + 1).then(resolve);
              } else {
                resolve([]);
              }
            }
          })
          .catch(() => {
            // catch异常也重试，最多5次
            if (num < 4) {
              this.generated(list, num + 1).then(resolve);
            } else {
              resolve([]);
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  height: auto;
  border: 1px solid rgba(245, 248, 255, 0.25);
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 16px 24px 2px rgba(0, 0, 0, 0.04);
  box-shadow: 0px 6px 30px 5px rgba(95, 88, 88, 0.05);
  backdrop-filter: blur(16.700000762939453px);
  border-radius: 12px;
  box-sizing: border-box;
  gap: 20px;
  .top {
    width: 100%;
    height: 50px;
    background: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    .t_left {
      white-space: nowrap;
      display: flex;
      gap: 20px;
      & > span {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #797979;
        cursor: pointer;
      }
      &>.active{
        font-size: 18px;
        color: #000;
      }
    }
    .t_right {
      display: flex;
      gap: 20px;
      & > img {
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
    }
  }

  .main {
    width: 100%;
    height: auto;
    background: #fafafa;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    box-sizing: border-box;
    padding: 20px;
    .m_item {
      width: 100%;
      height: auto;
      .mi_top {
        width: 100%;
        height: auto;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 12px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        & > div {
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;
          letter-spacing: 0;
        }
        & > span {
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
          letter-spacing: 0;
        }
      }
      .mi_userArea {
        margin-top: 20px;
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 12px 16px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.05);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        .mi_ua_top {
          width: 100%;
          height: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          & > span {
            font-weight: 600;
            font-size: 22px;
            line-height: 28px;
            color: rgba(34, 34, 34, 1);
            display: flex;
            align-items: center;

            & > span {
              font-weight: 500;
              font-size: 14px;
              line-height: 20px;
              letter-spacing: 18px;
              color: rgba(34, 34, 34, 1);
              margin-left: 10px;
            }
          }
          & > img {
            width: 16px;
            height: 16px;
            transform: rotate(0deg);
            transition: 0.3s;
            cursor: pointer;
            &.mi_ua_t_active {
              transform: rotate(180deg);
            }
          }
        }
        .mi_ua_userList {
          width: 100%;
          height: auto;
          display: flex;
          flex-wrap: wrap;
          overflow: hidden;
          gap: 10px;
          margin-top: 15px;
          .mi_ua_u_t_item {
            padding: 2px 8px;
            border-radius: 100px;
            background: rgba(0, 0, 0, 0.06);
            color: rgba(34, 34, 34, 1);
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: 0.2s;
            &:hover {
              background: rgba(209, 225, 255, 0.6);
              color: rgba(5, 96, 253, 1);
            }
          }
        }
        .mi_ua_u_active {
          height: 24px;
        }
      }
    }
  }
}

.mi_ua_u_t_i_popover {
  display: flex;
  flex-direction: column;
  gap: 15px;
  & > span {
    font-weight: 500;
    font-size: 14px;
    color: rgba(29, 33, 41, 1);
  }
  & > div {
    width: 100%;
    border-radius: 4px;
    border: solid 1px rgba(201, 205, 212, 1);
    padding: 6px 8px;
    font-size: 14px;
    box-sizing: border-box;
    font-weight: 400;
    color: rgba(29, 33, 41, 1);
  }
}
</style>
